// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3XqKL","selects":"Documents_selects__2r_Ya"};